import PanelInfo from './PanelInfo'
import BreakerPanels from './BreakerPanels'
import ModuleInfo from './ModuleInfo'
import BreakerInfo from './BreakerInfo'

export const PANEL_ROUTES = [
  {
    component: BreakerPanels,
    path: '',
    title: 'Breaker Panels',
  },
  {
    component: ModuleInfo,
    path: ':panelId/module/:moduleId',
    title: 'Breaker',
  },
  {
    component: BreakerInfo,
    path: ':panelId/breaker/:breakerId',
    title: 'Breaker',
  },
  {
    component: PanelInfo,
    path: ':panelId',
    title: 'Panel',
  },
]
